export const CORPORATE_EXPIRY_MESSAGE =
  "Subscription expired. Connect with your HR to seek assistance";

export const CIRCLE_CHECKOUT_BENEFITS = [
  {
    text: "Free delivery + up to 30% savings on medicine",
    imageName: "ic_medicines.png",
  },
  {
    text: "Save up to Rs.150 on Doctor Consultations",
    imageName: "doctor.svg",
  },
  {
    text: "Cashback + up to 60% off on Diagnostics",
    imageName: "diagnostics.svg",
    width: "16px",
  },
];

export enum MEMBERSHIP_REDIRECT_TYPES {
  REDIRECT = "REDIRECT",
  OPEN_DEEP_LINK = "OPEN_DEEP_LINK",
  REDIRECT_BASED_ON_PLATFORM = "REDIRECT_BASED_ON_PLATFORM",
}

export const MEMBERSHIP_PLAN_MAPPING = {
  circle: {
    planId: "CIRCLEPlan",
  },
  "care-first": {
    planId: "ApolloCareFirstPackage",
  },
  "family-doctor-plan": {
    planId: "FHP1",
  },
};

export const ecommCircleEventObj = {
  item_brand: "",
  item_category: "",
  item_category2: "",
  item_category3: "",
  item_category4: "",
  item_category5: "",
  item_list_id: "",
  item_list_name: "",
  item_variant: "",
  location_id: "",
  affiliation: "",
  item_name: "",
  item_id: "",
  coupon: "",
  discount: "",
  price: "",
  index: "",
  quantity: "",
};
